import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2, Trash2, AlertTriangle } from "lucide-react";

interface DeletePromotionConfirmationProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  promotionDetails: string;
  promotionId: number;
  onConfirm: (promotionId: number) => void;
  isLoading?: boolean;
}

const DeletePromotionConfirmation = ({
  open,
  onOpenChange,
  promotionDetails,
  promotionId,
  onConfirm,
  isLoading = false,
}: DeletePromotionConfirmationProps) => {
  const handleConfirm = () => {
    onConfirm(promotionId);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-destructive" />
            Delete Promotion
          </AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the promotion "
            <span className="font-semibold">{promotionDetails}</span>"?
            <br />
            <br />
            This action cannot be undone. The promotion will be permanently removed
            from the system and any unused promo codes will become invalid.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={isLoading}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isLoading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Deleting...
              </>
            ) : (
              <>
                <Trash2 className="w-4 h-4 mr-2" />
                Delete Promotion
              </>
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeletePromotionConfirmation;